export default __webpack_public_path__ + "static/media/rejectIcon.f9baca86.png";